import { defineStore } from "pinia";
import { StoreModule } from "@/constants/store.ts";

export enum SidebarId {
  AI_ASSISTANT = "aiAssistant",
  SETUP_HUB = "setupHub",
}

interface SidebarPanelState {
  openSidebarId: SidebarId | null;
}

const defaultSidebarPanelState: SidebarPanelState = {
  openSidebarId: null,
};

export const useSidebarPanelStore = defineStore(StoreModule.SIDEBAR_PANEL, {
  state: (): SidebarPanelState => ({ ...defaultSidebarPanelState }),
  persist: false,
  getters: {
    isOpen: (state) => (sidebarId: SidebarId) => state.openSidebarId === sidebarId,
    isAnySidebarOpen: (state) => state.openSidebarId !== null,
  },
  actions: {
    openSidebar(sidebarId: SidebarId) {
      this.openSidebarId = sidebarId;
    },
    closeSidebar() {
      this.openSidebarId = null;
    },
    toggleSidebar(sidebarId: SidebarId) {
      if (this.openSidebarId === sidebarId) {
        this.openSidebarId = null;
      } else {
        this.openSidebarId = sidebarId;
      }
    },
  },
});
